// src/utils/print-attribution.ts
var PRINT_ATTRIBUTION_PARAM = "pm";
var PRINT_ATTRIBUTION_HEADER = "X-FaveCard-Print";
var surfaces = { page: "p", card: "c" };
var formats = { mini: "l", medium: "t", large: "a", qrOnly: "q" };
var designs = { bold: "b", signature: "s", guide: "h", spotlight: "c", label: "l", qr: "q" };
var palettes = { paper: "w", ink: "k", brand: "c" };
var qrStyles = { rounded: "r", classic: "s", dots: "d", modern: "m" };
var languages = /* @__PURE__ */ new Set(["en", "pl", "es", "pt", "sk", "cs", "de", "fr", "it", "tr", "nl", "el", "hu", "ro", "uk", "sv", "da", "nb", "fi"]);
function encodePrintAttribution(input) {
  const qrOnly = input.format === "qrOnly";
  const mini = input.format === "mini";
  const design = qrOnly ? "qr" : mini ? "label" : input.design;
  const palette = qrOnly && input.palette !== "ink" ? "paper" : input.palette;
  const flags = Number(input.qrLogo) + Number(!qrOnly && input.brandLogo) * 2 + Number(!qrOnly && input.walletBadges) * 4 + Number(!qrOnly && input.customText) * 8 + Number(input.customColors) * 16;
  const language = qrOnly ? "--" : input.language && languages.has(input.language) ? input.language : "en";
  return `1${surfaces[input.surface]}${formats[input.format]}${designs[design]}${palettes[palette]}${qrStyles[input.qrStyle]}${flags.toString(36)}${language}`;
}
function keyFor(map, code) {
  return Object.keys(map).find((key) => map[key] === code);
}
function decodePrintAttribution(value) {
  if (typeof value !== "string" || value.length !== 9 || !/^1[a-z]{5}[0-9a-v](?:[a-z]{2}|--)$/.test(value)) return null;
  const surface = keyFor(surfaces, value[1]);
  const format = keyFor(formats, value[2]);
  const design = keyFor(designs, value[3]);
  const palette = keyFor(palettes, value[4]);
  const qrStyle = keyFor(qrStyles, value[5]);
  const language = value.slice(7) === "--" ? null : value.slice(7);
  if (!surface || !format || !design || !palette || !qrStyle || language !== null && !languages.has(language)) return null;
  if (format === "qrOnly" !== (design === "qr") || format === "mini" !== (design === "label")) return null;
  if (format === "qrOnly" !== (language === null)) return null;
  const flags = parseInt(value[6], 36);
  const result = {
    surface,
    format,
    design,
    palette,
    qrStyle,
    language,
    qrLogo: !!(flags & 1),
    brandLogo: !!(flags & 2),
    walletBadges: !!(flags & 4),
    customText: !!(flags & 8),
    customColors: !!(flags & 16)
  };
  return encodePrintAttribution(result) === value ? result : null;
}
function readPrintAttributionToken(search) {
  const params = new URLSearchParams(search);
  const values = params.getAll(PRINT_ATTRIBUTION_PARAM);
  if (params.get("demo") === "true" || params.has("preview")) return void 0;
  return values.length === 1 && decodePrintAttribution(values[0]) ? values[0] : void 0;
}
function withPrintAttribution(url, input) {
  try {
    const target = new URL(url);
    if (!["http:", "https:"].includes(target.protocol)) return url;
    target.searchParams.set(PRINT_ATTRIBUTION_PARAM, encodePrintAttribution(input));
    return target.toString();
  } catch {
    return url;
  }
}
function printAttributionProperties(value) {
  const material = decodePrintAttribution(value);
  if (!material) return {};
  return {
    print_material: value,
    print_material_version: 1,
    print_surface: material.surface,
    print_format: material.format,
    print_design: material.design,
    print_palette: material.palette,
    print_qr_style: material.qrStyle,
    print_qr_logo: material.qrLogo,
    print_brand_logo: material.brandLogo,
    print_wallet_badges: material.walletBadges,
    print_custom_text: material.customText,
    print_custom_colors: material.customColors,
    ...material.language && { print_language: material.language }
  };
}

export {
  PRINT_ATTRIBUTION_PARAM,
  PRINT_ATTRIBUTION_HEADER,
  encodePrintAttribution,
  decodePrintAttribution,
  readPrintAttributionToken,
  withPrintAttribution,
  printAttributionProperties
};
//# sourceMappingURL=chunk-KHFIF5LY.js.map